<template>
    <div id="menu">
        <b-navbar toggleable="lg" style="background-color: #5F5F5D">
            <b-navbar-toggle target="menu_nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="menu_nav_collapse">
                <b-nav vertical class="text-left">
                    <template>
                        <li
                            class="nav-item font text-white"
                            v-b-toggle.collapse>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/dashboard.png"
                                     width="30px"/>
                            </span>
                            <span class="col-sm-4">แดชบอร์ด&nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="collapse">
                            <!--                            <nav-item-->
                            <!--                                v-if="canViewSuperAdmin"-->
                            <!--                                router-link-->
                            <!--                                to="/dashboard-overview"-->
                            <!--                                class="padding-left font"-->
                            <!--                                :class="overviewDashboardActive()">-->
                            <!--                                <icon-->
                            <!--                                    name="file-alt"-->
                            <!--                                    style="width: 25px;color: #A258DC">-->
                            <!--                                </icon>-->
                            <!--                                ภาพรวม-->
                            <!--                            </nav-item>-->
                            <nav-item
                                v-if="canViewSuperAdmin"
                                router-link
                                to="/report-product"
                                class="padding-left font"
                                :class="dashboardReportActive()">
                                <icon name="file-alt" style="width: 25px;color: #A258DC"></icon>
                                รายงาน
                            </nav-item>
                            <nav-item
                                router-link to="/report-update-data"
                                :class="reportUpdateActive()"
                                class="padding-left font">
                                <icon name="file-alt" style="width: 25px;color: #A258DC"></icon>
                                รายงานการอัพเดตข้อมูล
                            </nav-item>
                            <nav-item
                                router-link to="/record-message"
                                :class="reportRecordActive()"
                                class="padding-left font">
                                <icon name="calendar-check" style="width: 25px;color: #A258DC"></icon>
                                บันทึกข้อความจากเฮีย/คุณมด
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template
                        v-if="canInventoryView || canViewPurchases || canViewAccounting || canSaleView || accessUser.includes(this.user.username)">
                        <li class="nav-item font text-white" v-b-toggle.collapse1>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/inventory.png"
                                     width="30px"/>
                            </span>
                            <span class="col-sm-4">คลังสินค้า &nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="collapse1">
                            <nav-item
                                router-link
                                to="/overview"
                                :class="overviewActive()"
                                v-if="canInventoryOverviewView || accessUser.includes(this.user.username)"
                                class="padding-left font">
                                <icon name="file-alt" style="width: 25px;color: #DC5880"></icon>
                                รายงานการจองสินค้า
                            </nav-item>
                            <nav-item
                                router-link
                                to="/products"
                                @click="productRouter"
                                v-if="canInventoryProductsView || accessUser.includes(this.user.username) || accessUserSpecial.includes(user.username)"
                                :class="productActive()"
                                class="padding-left font">
                                <icon name="tag" style="width: 25px;color: #DC5880"></icon>
                                สต็อคสินค้า
                            </nav-item>
                            <nav-item
                                router-link
                                to="/materials"
                                @click="materialRouter"
                                v-if="canInventoryMaterialsView ||
                                canViewPurchases ||
                                canInventoryReportsProductsView"
                                :class="materialActive()"
                                class="padding-left font">
                                <icon name="boxes"
                                      style="width: 25px;color: #DC5880"></icon>
                                รายการวัตถุดิบ
                            </nav-item>
                            <nav-item
                                v-if="canInventoryView || canViewPurchases"
                                class="padding-left font"
                                :class="factorialMaterialActive()"
                                router-link
                                to="/factorial-material-list">
                                <icon name="paperclip"
                                      style="width: 25px;color: #DC5880"></icon>
                                วัสดุอุปกรณ์โรงงาน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                @click="sheetRouter"
                                v-if="canInventorySheetsView"
                                :class="sheetActive()"
                                router-link
                                to="/sheet">
                                <icon name="toilet-paper" style="width: 25px;color: #DC5880"></icon>
                                รายการสต็อคชีท
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                @click="reportRouter"
                                :class="reportActive()"
                                v-if="canInventoryReportsView || canViewAccounting || canSaleView"
                                router-link
                                to="/production-report">
                                <icon name="cogs" style="width: 25px;color: #DC5880"></icon>
                                รายงานการสั่งผลิต
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                to="/report-compare-product"
                                :class="reportCompareActive()"
                                v-if="canInventoryReportsView || canViewAccounting"
                                router-link>
                                <icon name="file-alt" style="width: 25px;color: #DC5880"></icon>
                                รายงานเปรียบเทียบการผลิต
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                to="/product-standard1"
                                :class="productStandardActive()"
                                router-link>
                                <icon name="file-alt" style="width: 25px;color: #DC5880"></icon>
                                มาตรฐานการผลิตสินค้า
                            </nav-item>
                            <nav-item
                                v-if="canViewSuperAdmin"
                                class="padding-left font"
                                to="/product-cost1"
                                :class="productCostActive()"
                                router-link>
                                <icon name="file-alt" style="width: 25px;color: #DC5880"></icon>
                                วิเคราะห์ต้นทุน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                to="/product-weight1"
                                :class="productWeightActive()"
                                router-link>
                                <icon name="file-alt" style="width: 25px;color: #DC5880"></icon>
                                เช็คน้ำหนัก
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template v-if="canInventoryView || canViewPurchases">
                        <li class="nav-item font text-white" v-b-toggle.purchase-collapse>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/purchase.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">การจัดซื้อ &nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="purchase-collapse">
                            <nav-item
                                router-link
                                to="/pre-order"
                                @click="purchaseOrderRouter"
                                :class="PurchaseActive()"
                                class="padding-left font">
                                <icon name="file" style="width: 25px;color: #DC7858"></icon>
                                สร้าง PO
                            </nav-item>
                            <nav-item
                                v-if="!hideWarehouseLead"
                                router-link
                                to="/rr-list"
                                @click="rrRouter"
                                :class="RRAction()"
                                class="padding-left font">
                                <icon name="file-invoice" style="width: 25px;color: #DC7858"></icon>
                                ตัด RR
                            </nav-item>
                            <nav-item v-if="!hideWarehouseLead"
                                      router-link
                                      to="/checked-bag"
                                      @click="checkedBagRouter"
                                      :class="checkedBagActive()"
                                      class="padding-left font">
                                <icon name="shopping-bag" style="width: 25px;color: #DC7858"></icon>
                                เช็คถุง
                            </nav-item>
                            <nav-item v-if="!hideWarehouseLead"
                                      router-link
                                      to="/payment-list"
                                      @click="paymentRouter"
                                      :class="paymentActive()"
                                      class="padding-left font">
                                <icon name="coins" style="width: 25px;color: #DC7858"></icon>
                                ตั้งยอดเบิก-จ่าย
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template v-if="canSaleView || canViewDriver || canViewHR || canViewPurchases">
                        <li class="nav-item font text-white" v-b-toggle.sell-collapse>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/sale.png"
                                     width="30px"/>
                            </span>
                            <span class="col-sm-4">การขาย &nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="sell-collapse">
                            <nav-item
                                class="padding-left font"
                                v-if="canSaleView || canViewHR || canViewPurchases"
                                :class="overviewSaleActive()"
                                router-link
                                to="/overview-sale-list">
                                <icon name="file-alt" style="width: 25px;color: #DCB758"></icon>
                                ภาพรวมการขาย
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                v-if="canSaleView"
                                :class="stockProductForSale()"
                                router-link
                                to="/stock-product">
                                <icon name="warehouse" style="width: 25px;color: #DCB758"></icon>
                                สต็อคสินค้า
                            </nav-item>
                            <nav-item v-if="canSaleView || canViewDriver"
                                      @click="orderRouter"
                                      :class="orderActive()"
                                      router-link
                                      :to="driverPermission()"
                                      class="padding-left font">
                                <icon name="file" style="width: 25px;color: #DCB758"></icon>
                                ใบแจ้งหนี้
                            </nav-item>
                            <template v-if="canViewAccounting">
                                <nav-item
                                    router-link
                                    to="/promotions"
                                    @click="promotionRouter"
                                    :class="promotionActive()"
                                    class="padding-left font">
                                    <icon name="money-bill-wave-alt" style="width: 25px;color: #DCB758"></icon>
                                    โปรโมชั่น
                                </nav-item>
                            </template>
                            <template v-if="canSaleView">
                                <nav-item
                                    router-link
                                    to="/sale-return-products"
                                    @click="saleReturnProductsRouter"
                                    :class="saleReturnProductsActive()"
                                    class="padding-left font">
                                    <icon name="undo-alt" style="width: 25px;color: #DCB758"></icon>
                                    คืนสินค้า
                                </nav-item>
                            </template>
                            <template>
                                <nav-item
                                    router-link
                                    :to="quotaRoute()"
                                    @click="quotaRouter"
                                    :class="quotaActive()"
                                    class="padding-left font">
                                    <icon name="cogs" style="width: 25px;color: #DCB758"></icon>
                                    ตั้งค่าโควต้า
                                </nav-item>
                            </template>
                            <!--                            <template>-->
                            <!--                                <nav-item-->
                            <!--                                    router-link-->
                            <!--                                    to="/quota-sale-list"-->
                            <!--                                    @click="quotaSaleRouter"-->
                            <!--                                    :class="quotaSaleActive()"-->
                            <!--                                    class="padding-left font">-->
                            <!--                                    <icon name="cogs" style="width: 25px;color: #DCB758"></icon>-->
                            <!--                                    โควต้าเซล-->
                            <!--                                </nav-item>-->
                            <!--                            </template>-->
                        </b-collapse>
                    </template>
                    <template v-if="canViewSuperAdmin">
                        <nav-item
                            router-link
                            :to="productsRoute()"
                            class="font"
                            :class="productsActive()">
                            <span class="col-sm-2">
                                <img src="@/assets/icons/inventory.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">สินค้า</span>
                        </nav-item>
                    </template>
                    <template v-if="canCustomerView && !hideWarehouseLead">
                        <nav-item
                            router-link
                            :to="purchaseRoute()"
                            class="font"
                            @click="customerRouter"
                            :class="customerActive()">
                            <span class="col-sm-2">
                                <img src="@/assets/icons/customer.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">ลูกหนี้-เจ้าหนี้</span>
                        </nav-item>
                    </template>
                    <template
                        v-if="(canViewAccounting ||canViewDriver || canViewDriverAll || canViewPurchases || canInventoryView) && user.id != 3 ">
                        <li class="nav-item font text-white" v-b-toggle.transport>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/truck.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">การขนส่ง &nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="transport">
                            <nav-item
                                class="padding-left font"
                                router-link
                                to="/driver"
                                v-if="canViewAccounting || canViewDriver || canViewDriverAll"
                                @click="driverRouter"
                                :class="driverActive()">
                                <icon name="user" style="width: 25px;color: #58DCAC"></icon>
                                คนขับรถ
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                router-link
                                :to="accountTransportRoute()"
                                v-if="canViewAccounting ||canViewDriver ||canViewDriverAll"
                                @click="accountTransportRouter"
                                :class="accountTransportActive()">
                                <icon name="clipboard" style="width: 25px;color: #58DCAC"></icon>
                                บันทึกค่าใช้จ่าย
                            </nav-item>
                            <nav-item
                                router-link
                                to="/shipping-fee"
                                v-if="!canViewPurchases || canViewAccounting || canViewSuperAdmin"
                                @click="shippingRouter"
                                :class="shippingActive()"
                                class="padding-left font">
                                <icon name="money-check-alt" style="width: 25px;color: #58DCAC"></icon>
                                ค่าเที่ยวและค่าขนส่ง
                            </nav-item>
                            <nav-item
                                router-link
                                to="/transportation"
                                v-if="!canViewPurchases || canViewAccounting || canViewSuperAdmin"
                                @click="transportRouter"
                                :class="transportActive()"
                                class="padding-left font">
                                <icon name="truck" style="width: 25px;color: #58DCAC"></icon>
                                ขนส่ง
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template v-if="(canViewAccounting || canViewPurchases || canSaleView) && user.id != 3 ">
                        <li class="nav-item font text-white" v-b-toggle.accounting>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/accounting.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">ระบบบัญชี &nbsp;&nbsp;
                                <icon name="caret-down"></icon></span>
                        </li>
                        <b-collapse id="accounting">
                            <nav-item
                                class="padding-left font"
                                router-link
                                to="/accounting/billing/receivable"
                                v-if="canViewAccounting || canSaleView"
                                @click="billingRouter"
                                :class="billingActive()">
                                <icon name="file-alt" style="width: 25px;color: #58BCDC"></icon>
                                ใบวางบิล
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                router-link
                                @click="payoffRouter"
                                v-if="canViewAccounting || canSaleView || canViewPurchases"
                                :class="payOffActive()">
                                <icon name="file-excel" style="width: 25px;color: #58BCDC"></icon>
                                บันทึกรับ
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                router-link
                                to="/accounting/rr-payoff/payment"
                                @click="rrPayoffRouter"
                                v-if="canViewPurchases || canViewAccounting"
                                :class="rrPayoff()">
                                <icon name="money-bill-wave-alt" style="width: 25px;color: #58BCDC"></icon>
                                บันทึกจ่าย
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                :class="bankActive()"
                                v-if="canViewAccounting"
                                router-link
                                to="/accounting/Bank">
                                <icon name="money-check-alt" style="width: 25px;color: #58BCDC"></icon>
                                ธนาคาร
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                v-if="canViewAccounting || taxAccess.includes(user.username)"
                                :to="taxInvoiceRouter()"
                                :class="taxInvoiceActive()"
                                router-link>
                                <icon name="file-invoice" style="width: 25px;color: #58BCDC"></icon>
                                ใบกำกับภาษี
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                v-if="canViewSuperAdmin"
                                :class="realizedGainLossActive()"
                                router-link
                                to="/realized-gain-loss-form">
                                <icon name="dollar-sign" style="width: 25px;color: #58BCDC"></icon>
                                กำไร-ขาดทุน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                v-if="canViewAccounting"
                                :class="creditDebitActive()"
                                router-link
                                to="/account/statement">
                                <icon name="piggy-bank" style="width: 25px;color: #58BCDC"></icon>
                                รายการเดบิต - เครดิต
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template v-if="canViewHR || factoryAccess.includes(user.username)">
                        <li class="nav-item font text-white" v-b-toggle.hr>
                            <span class="col-sm-2">
                                <img src="@/assets/icons/hr.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">ฝ่ายบุคคล &nbsp;&nbsp;
                                <icon name="caret-down"></icon>
                            </span>
                        </li>
                        <b-collapse id="hr">
                            <nav-item
                                class="padding-left font"
                                @click="hrRouter"
                                :class="hrActive()"
                                v-if="canViewHR || user.username == '20674'"
                                router-link
                                to="/hr/work-schedules">
                                <icon name="clock" style="width: 25px;color: #7E93FF"></icon>
                                ตารางเวลางาน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                @click="employeeRouter"
                                :class="employeeActive()"
                                v-if="canViewHR || user.username == '20674'"
                                router-link
                                to="/hr/employee">
                                <icon name="users" style="width: 25px;color: #7E93FF"></icon>
                                พนักงาน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                :class="importActive()"
                                v-if="canViewHR || user.username == '20674'"
                                router-link
                                to="/hr/import-work-time">
                                <icon name="clock" style="width: 25px;color: #7E93FF"></icon>
                                นำเข้าเวลาการทำงาน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                :class="paymentSalaryActive()"
                                v-if="canViewHR || user.username == '20674'"
                                router-link
                                to="/hr/payment-salary">
                                <icon name="dollar-sign" style="width: 25px;color: #7E93FF"></icon>
                                คำนวณเงินเดือน
                            </nav-item>
                            <nav-item
                                class="padding-left font"
                                :class="settingEmployeeActive()"
                                v-if="canViewHR || user.username == '20674'"
                                router-link
                                to="/setting-department">
                                <icon name="users-cog" style="width: 25px;color: #7E93FF"></icon>
                                ตั้งค่าพนักงาน
                            </nav-item>
                            <nav-item
                                v-if="canViewHR || factoryAccess.includes(user.username)"
                                class="padding-left font"
                                :class="factoryProductActive()"
                                router-link
                                to="/factory-product">
                                <icon name="tshirt" style="width: 25px;color: #7E93FF"></icon>
                                สินค้าโรงงาน
                            </nav-item>
                            <nav-item
                                v-if="canViewHR || factoryAccess.includes(user.username)"
                                :class="factoryProductSaleActive()"
                                router-link to="/factory-product-sale"
                                class="padding-left font">
                                <icon name="tshirt" style="width: 25px;color: #7E93FF"></icon>
                                จำหน่ายสินค้าโรงงาน
                            </nav-item>
                        </b-collapse>
                    </template>
                    <template v-if="canViewSuperAdmin">
                        <nav-item
                            router-link
                            :to="usersRoute()"
                            class="font"
                            :class="usersActive()">
                            <!--                            <icon name="person-plus" style="width: 25px;"></icon>-->
                            <span class="col-sm-2">
                                <img src="@/assets/icons/hr.png" width="30px"/>
                            </span>
                            <span class="col-sm-4">ผู้ใช้งาน</span>
                        </nav-item>
                    </template>
                    <nav-item href="#" @click="showLogoutModal">
                        <span class="col-sm-2">
                            <img src="@/assets/icons/logout.png" width="30px"/>
                        </span>
                        <span class="col-sm-4">ออกจากระบบ</span>
                    </nav-item>
                    <nav-item>
                        <span style="color: white">
                            Version.1.2.20_20240601
                            <div style="font-size: 15px"></div>
                        </span>
                    </nav-item>
                </b-nav>
            </b-collapse>
        </b-navbar>
        <!-- Modal Delete -->
        <b-modal ref="logout" hide-header hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการออกจากระบบใช่หรือไม่</h4>
                <br/>
                <button type="button" class="btn btn-success" @click="logout">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button type="button"
                        class="btn btn-outline-secondary"
                        @click="hideLogoutModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import NavItem from "bootstrap-vue/src/components/nav/nav-item";
import NavItemDropdown from "bootstrap-vue/src/components/nav/nav-item-dropdown";
import {mapState} from "vuex";

import {
    canCustomerCustomersSpecialView,
    canCustomerCustomersView,
    canCustomerView,
    canInventoryMaterialsView,
    canInventoryOverviewView,
    canInventoryProductsView,
    canInventoryReportsProductsView,
    canInventoryReportsView,
    canInventorySheetsView,
    canInventoryView,
    canSaleOrdersAllView,
    canSaleView,
    canVendorsView,
    canViewAccounting,
    canViewDashboard,
    canViewDriver,
    canViewDriverAll,
    canViewHR,
    canViewPurchases,
    canViewSuperAdmin,
    canViewTransports,
    hideWarehouseLead,
} from "../util/Permissions";

export default {
    components: {
        NavItemDropdown,
        NavItem
    },
    name: "menu-sidebar",
    computed: {
        canViewSuperAdmin,
        canViewDashboard,
        canInventoryView,
        canInventoryOverviewView,
        canInventoryProductsView,
        canInventoryMaterialsView,
        canInventorySheetsView,
        canInventoryReportsView,
        canSaleView,
        canSaleOrdersAllView,
        canCustomerView,
        canCustomerCustomersView,
        canCustomerCustomersSpecialView,
        canViewPurchases,
        canViewTransports,
        canViewAccounting,
        canViewHR,
        canVendorsView,
        canViewDriver,
        canViewDriverAll,
        canInventoryReportsProductsView,
        hideWarehouseLead,
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    },
    data() {
        return {
            seen: false,
            accessUser: [
                "10389",
                "20502",
                "20534",
                "20566",
                "10071",
                "10070",
                "10388",
                "10389",
                "10618",
                "20505",
                "20507",
                "10803",
                "10502",
            ],
            accessUserSpecial: [
                "10228",
                "10701",
                "10223",
                "20648",
                "10502",
            ],
            factoryAccess: [
                "20682",
                "20609",
                "20674",
                "20707",
                "20732",
                "20711"
            ],
            taxAccess: [
                "20682",
                "20609",
                "20707"
            ]
        };
    },
    methods: {
        taxInvoiceRouter() {
            if (this.taxAccess.includes(this.user.username)) {
                return "/accounting/tax-customer";
            } else {
                return "/accounting/tax-invoice";
            }
        },
        logout() {
            return this.$store
                .dispatch("Auth/logout")
                .then(() => this.$router.push("/login"));
        },
        reportUpdateActive() {
            return {
                active:
                    this.$route.path === "/report-update-data"
            };
        },
        reportRecordActive() {
            return {
                active:
                    this.$route.path === "/record-message"
            };
        },
        purchaseRoute() {
            if (
                this.canVendorsView &&
                !this.canCustomerCustomersView &&
                !this.canCustomerCustomersSpecialView
            ) {
                return "/vendor";
            } else if (
                !this.canVendorsView &&
                !this.canCustomerCustomersView &&
                this.canCustomerCustomersSpecialView
            ) {
                return "/canCustomerCustomersSpecialView";
            } else {
                return "/customer";
            }
        },
        productsRoute() {
            if (this.canViewSuperAdmin) {
                return "/products-stock";
            }
        },
        usersRoute() {
            if (this.canViewSuperAdmin) {
                return "/user-management";
            }
        },
        driverPermission() {
            if (this.canViewDriverAll || this.canSaleView) {
                return "/orders";
            } else {
                return "/save-exportation";
            }
        },
        customerRouter() {
            this.$store.dispatch("Customer/setCustomer").then(() => {
                this.$store.dispatch("Customer/clearSearch");
            });
        },
        customerActive() {
            return {
                active:
                    this.$route.path === "/customer" ||
                    this.$route.path === "/customer-information" ||
                    this.$route.path === "/vendor" ||
                    this.$route.path === "/vendor-information" ||
                    this.$route.path === "/special-customer" ||
                    this.$route.path === "/special-customer-form" ||
                    this.$route.path === "/customer-other"
            };
        },
        productsActive() {
            return {
                active:
                    this.$route.path === "/products-stock"
            };
        },
        usersActive() {
            return {
                active:
                    this.$route.path === "/user-management"
            };
        },
        productRouter() {
            this.$store.dispatch("Products/setProducts");
            this.$store.dispatch("Products/clearSearch");
        },
        productActive() {
            return {
                active:
                    this.$route.path === "/products" ||
                    this.$route.path === "/import_products" ||
                    this.$route.path === "/export_products" ||
                    this.$route.path === "/products-information"
            };
        },
        materialRouter() {
            this.$store.dispatch("Material/get", 1).then(() => {
                this.$store.dispatch("Material/clearSearch");
            });
        },
        materialActive() {
            return {
                active:
                    this.$route.path === "/materials" ||
                    this.$route.path === "/materials-import" ||
                    this.$route.path === "/materials-export" ||
                    this.$route.path === "/materials-information"
            };
        },
        factorialMaterialActive() {
            return {
                active:
                    this.$route.path === "/factorial-material-list" ||
                    this.$route.path === "/factorial-material-import" ||
                    this.$route.path === "/factorial-material-export" ||
                    this.$route.path === "/factorial-material-information"
            };
        },
        sheetRouter() {
            this.$store.dispatch("Sheet/get").then(() => {
                this.$store.dispatch("Sheet/clearSearch");
            });
        },
        sheetActive() {
            return {
                active:
                    this.$route.path === "/sheet" ||
                    this.$route.path === "/sheet-import" ||
                    this.$route.path === "/sheet-export" ||
                    this.$route.path === "/sheet-information"
            };
        },
        overviewDashboardActive() {
            return {
                active:
                    this.$route.path === "/dashboard-overview" ||
                    this.$route.path === "/dashboard-selling"
            };
        },
        dashboardReportActive() {
            return {
                active:
                    this.$route.path === "/report-group-product" ||
                    this.$route.path === "/report-product" ||
                    this.$route.path === "/report-group-customer" ||
                    this.$route.path === "/report-compare-product" ||
                    this.$route.path === "/report-invoice-sale"
            };
        },
        reportUpdateDataActive() {
            return {
                active:
                    this.$route.path === "/report-update-data"
            };
        },
        reportRecordMessageActive() {
            return {
                active:
                    this.$route.path === "/record-message"
            };
        },
        overviewActive() {
            return {
                active: this.$route.path === "/overview"
            };
        },
        reportRouter() {
            this.$store.dispatch("ReportProduct/get").then(() => {
                this.$store.dispatch("ReportProduct/clearSearch");
            });
        },
        reportActive() {
            return {
                active:
                    this.$route.path === "/production-report" ||
                    this.$route.path === "/sheet-report" ||
                    this.$route.path === "/sheet-report-information" ||
                    this.$route.path === "/production-report-information" ||
                    this.$route.path === "/machine-product" ||
                    this.$route.path === "/machine-sheet" ||
                    this.$route.path === "/machine-product-form" ||
                    this.$route.path === "/machine-sheet-form"
            };
        },
        orderRouter() {
            // this.$store.dispatch("Order/setOrders").then(() => {
            //     this.$store.dispatch("Order/clearSearch");
            // });
        },
        reportCompareActive() {
            return {
                active:
                    this.$route.path === "/report-compare-product"
            };
        },
        productStandardActive() {
            return {
                active:
                    this.$route.path === "/product-standard1" ||
                    this.$route.path === "/product-standard2" ||
                    this.$route.path === "/product-standard3"
            };
        },
        productWeightActive() {
            return {
                active:
                    this.$route.path === "/product-weight1" ||
                    this.$route.path === "/product-weight2" ||
                    this.$route.path === "/product-weight3" ||
                    this.$route.path === "/product-weight4" ||
                    this.$route.path === "/product-weight5"
            };
        },
        productCostActive() {
            return {
                active:
                    this.$route.path === "/product-cost1" ||
                    this.$route.path === "/product-cost2" ||
                    this.$route.path === "/product-cost3" ||
                    this.$route.path === "/product-cost4" ||
                    this.$route.path === "/product-cost5" ||
                    this.$route.path === "/product-cost6"
            };
        },
        orderActive() {
            return {
                active:
                    this.$route.path === "/orders" ||
                    this.$route.path === "/invoices" ||
                    this.$route.path === "/order" ||
                    this.$route.path === "/invoice" ||
                    this.$route.path === "/save-exportation" ||
                    this.$route.path === "/save-exportation-form" ||
                    this.$route.path === "/example-product" ||
                    this.$route.path === "/example-gift"
            };
        },
        overviewSaleActive() {
            return {
                active: this.$route.path === "/overview-sale-list"
                    || this.$route.path === "/transport-fee-report"
                    || this.$route.path === "/tax-driver-report"
            };
        },
        stockProductForSale() {
            return {
                active: this.$route.path === "/stock-product"
            };
        },
        employeeRouter() {
            this.$store.dispatch("Employee/setEmployee").then(() => {
                this.$store.dispatch("Employee/clearSearch");
            });
        },
        employeeActive() {
            return {
                active:
                    this.$route.path === "/hr/employee" ||
                    this.$route.path === "/hr/rate-salary" ||
                    this.$route.path === "/hr/sale-bonus" ||
                    this.$route.path === "/hr/work-schedule-history" ||
                    this.$route.path === "/hr/employee-information/profile" ||
                    this.$route.path === "/hr/employee-information/salary" ||
                    this.$route.path === "/hr/employee-information/quarantee" ||
                    this.$route.path === "/hr/employee-information/leaveDay" ||
                    this.$route.path === "/hr/employee-information/tax" ||
                    this.$route.path === "/hr/employee-information/card_employee" ||
                    this.$route.path === "/hr/employee-information/insurance"

            };
        },
        purchaseOrderRouter() {
            this.$store.dispatch("PreOrder/setPreOrder").then(() => {
                this.$store.dispatch("PreOrder/clearSearch");
            });
        },
        PurchaseActive() {
            return {
                active:
                    this.$route.path === "/pre-order" ||
                    this.$route.path === "/purchase-order" ||
                    this.$route.path === "/purchase-form"
            };
        },
        rrRouter() {
            this.$store.dispatch("RROrder/setRROrder");
            this.$store.dispatch("RROrder/clearSearch");
        },
        RRAction() {
            return {
                active:
                    this.$route.path === "/rr-list" ||
                    this.$route.path === "/rr-form" ||
                    this.$route.path === "/rr-form-details"
            };
        },
        driverRouter() {
            this.$store.dispatch("Driver/setDriver");
            this.$store.dispatch("Driver/clearSearch");
        },
        driverActive() {
            return {
                active:
                    this.$route.path === "/driver" ||
                    this.$route.path === "/driver-form" ||
                    this.$route.path === "/driver-shipping" ||
                    this.$route.path === "/driver-bonus" ||
                    this.$route.path === "/driver-transport-report"
            };
        },
        transportRouter() {
            this.$store.dispatch("Transportation/setTransportShow").then(() => {
                this.$store.dispatch("Transportation/clearSearch");
            });
        },
        transportActive() {
            return {
                active:
                    this.$route.path === "/transportation" ||
                    this.$route.path === "/transportation-form"
            };
        },
        accountTransportRoute() {
            if (this.canViewPurchases) {
                return "/deposit";
            } else {
                return "/insurance-fee";
            }
        },
        accountTransportRouter() {
            this.$store.dispatch("InsuranceFee/setInsuranceFee");
            this.$store.dispatch("InsuranceFee/clearSearch");
        },
        accountTransportActive() {
            return {
                active:
                    this.$route.path === "/insurance-fee" ||
                    this.$route.path === "/insurance-information" ||
                    this.$route.path === "/deposit" ||
                    this.$route.path === "/deposit-information" ||
                    this.$route.path === "/cost-repair" ||
                    this.$route.path === "/cost-damages" ||
                    this.$route.path === "/car-fee-information" ||
                    this.$route.path === "/car-fee" ||
                    this.$route.path === "/damages-information"
            };
        },
        shippingRouter() {
            this.$store.dispatch("Customer/setCustomer");
            this.$store.dispatch("Shipping/clearSearch");
        },
        shippingActive() {
            return {
                active:
                    this.$route.path === "/shipping-fee" ||
                    this.$route.path === "/edit-shipping" ||
                    this.$route.path === "/transport-fee"
            };
        },
        checkedBagRouter() {
            this.$store.dispatch("BagData/clearSearch");
            this.$store.dispatch("BagData/setBagData");
            this.$store.dispatch("CheckBag/setCheckedBag");
        },
        checkedBagActive() {
            return {
                active:
                    this.$route.path === "/checked-bag" ||
                    this.$route.path === "/bag-type"
            };
        },
        paymentRouter() {
            this.$store.dispatch("PurchasePayment/setPayment");
            this.$store.dispatch("PurchasePayment/clearSearch");
        },
        paymentActive() {
            return {
                active:
                    this.$route.path === "/payment-list" ||
                    this.$route.path === "/payment-form"
            };
        },
        billingRouter() {
            let seller_id = "";
            if (this.canSaleOrdersAllView) {
                seller_id = "";
            } else {
                seller_id = this.user.id;
            }
            let search = {
                date: [],
                customer_id: "",
                sale_id: seller_id,
                sale: "",
                customer: ""
            };
            this.$store.dispatch("Receivable/clearSearch").then(() => {
                this.$store.dispatch("Receivable/setReceivables", {
                    page: 1,
                    search: search
                });
            });
        },
        billingActive() {
            return {
                active:
                    this.$route.path === "/accounting/billing/sellers" ||
                    this.$route.path === "/accounting/billing/receivable" ||
                    this.$route.path === "/accounting/billing/receivables" ||
                    this.$route.path === "/accounting/billing/receivable/1" ||
                    this.$route.path === "/accounting/billing/billings" ||
                    this.$route.path === "/accounting/billing/payments" ||
                    this.$route.path ===
                    "/accounting/billing/billings/status/1" ||
                    this.$route.path ===
                    "/accounting/billing/billings/status/2" ||
                    this.$route.path ===
                    "/accounting/billing/billings/status/3" ||
                    this.$route.path === "/accounting/billing/billings/status/4"
            };
        },
        payoffRouter() {
            if (this.canViewAccounting) {
                this.$router.push('/accounting/payoff')
                this.$store.dispatch("InvoicePayoff/clearSearch");
                this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                    transaction_type_id: ""
                });
            } else if (this.canSaleView) {
                this.$router.push('/accounting/cheque-list')
            } else if (this.canViewPurchases) {
                this.$router.push('/accounting/invoice-payoff-other')
            }
        },
        payOffActive() {
            return {
                active:
                    this.$route.path === "/accounting/payoff" ||
                    this.$route.path === "/accounting/billing-payoff" ||
                    this.$route.path === "/accounting/billing-payoff-form" ||
                    this.$route.path ===
                    "/accounting/billing-payoff/transaction-type/1" ||
                    this.$route.path ===
                    "/accounting/billing-payoff/transaction-type/2" ||
                    this.$route.path ===
                    "/accounting/billing-payoff/transaction-type/3" ||
                    this.$route.path ===
                    "/accounting/billing-payoff/cancelled" ||
                    this.$route.path === "/accounting/billing-payoff/create" ||
                    this.$route.path === "/accounting/cheque-list" ||
                    this.$route.path === "/invoice-payoff" ||
                    this.$route.path === "/invoice-payoff-transactions" ||
                    this.$route.path === "/accounting/invoice-payoff-other" ||
                    this.$route.path === "/accounting/invoice-payoff-account" ||
                    this.$route.path === "/invoice-payoff-other-form" ||
                    this.$route.path === "/invoice-payoff-other-transactions"
            };
        },
        bankActive() {
            return {
                active: this.$route.path === "/accounting/Bank"
            };
        },
        taxInvoiceActive() {
            return {
                active:
                    this.$route.path === "/accounting/tax-invoice" ||
                    this.$route.path === "/accounting/tax-payoff" ||
                    this.$route.path === "/accounting/tax-payment" ||
                    this.$route.path === "/accounting/tax-payment-form" ||
                    this.$route.path === "/accounting/billing-RE" ||
                    this.$route.path === "/accounting/billing-RE-form" ||
                    this.$route.path === "/accounting/tax-invoice-form" ||
                    this.$route.path === "/accounting/tax-payment-account" ||
                    this.$route.path === "/accounting/credit-note" ||
                    this.$route.path === "/accounting/tax-customer" ||
                    this.$route.path === "/accounting/tax-customer-info"
            };
        },
        creditNoteActive() {
            return {
                active:
                    this.$route.path === "/accounting/credit-note"
            };
        },
        rrPayoffRouter() {
            this.$store.dispatch("RRPayoff/getRRpayoff").then(() => {
                this.$store.dispatch("RRPayoff/clearSearch");
            });
        },
        rrPayoff() {
            return {
                active:
                    this.$route.path === "/accounting/rr-payoff/payment" ||
                    this.$route.path === "/accounting/rr-payoff/payoff" ||
                    this.$route.path === "/accounting/rr-payoff/account" ||
                    this.$route.path === "/accounting/rr-payoff/form1" ||
                    this.$route.path === "/accounting/rr-payoff/other" ||
                    this.$route.path === "/accounting/rr-payoff/cheque" ||
                    this.$route.path === "/accounting/payoff/payment-project" ||
                    this.$route.path === "/accounting/payoff/po" ||
                    this.$route.path === "/accounting/rr-payoff/mile-seller"
            };
        },
        realizedGainLossActive() {
            return {
                active:
                    this.$route.path === "/realized-gain-loss-list" ||
                    this.$route.path === "/realized-gain-loss-form"
            };
        },
        importActive() {
            return {
                active: this.$route.path === "/hr/import-work-time" ||
                    this.$route.path === "/hr/import-ot-hour"
            };
        },
        paymentSalaryActive() {
            return {
                active:
                    this.$route.path === "/hr/payment-salary" ||
                    this.$route.path === "/hr/rental-fee" ||
                    this.$route.path === "/hr/electricity-bill" ||
                    this.$route.path === "/hr/shopping" ||
                    this.$route.path === "/hr/advance-payment" ||
                    this.$route.path === "/hr/payment-salary-history" ||
                    this.$route.path === "/hr/payment-salary-slip" ||
                    this.$route.path === "/hr/shopping-form" ||
                    this.$route.path === "/hr/other-payment-form" ||
                    this.$route.path === "/hr/other-payment"
            };
        },
        factoryProductActive() {
            return {
                active:
                    this.$route.path === "/factory-product" ||
                    this.$route.path === "/import-factory-product" ||
                    this.$route.path === "/export-factory-product" ||
                    this.$route.path === "/factory-form"
            };
        },
        factoryProductSaleActive() {
            return {
                active:
                    this.$route.path === "/factory-product-sale" ||
                    this.$route.path === "/factory-sale-form"
            };
        },
        settingEmployeeActive() {
            return {
                active:
                    this.$route.path === "/setting-department" ||
                    this.$route.path === "/setting-position" ||
                    this.$route.path === "/setting-department" ||
                    this.$route.path === "/setting-social-security" ||
                    this.$route.path === "/setting-tax-rate"
            };
        },
        hrRouter() {
            this.$store.dispatch("WorkScheduleEmployee/setWorkScheduleList");
        },
        hrActive() {
            return {
                active:
                    this.$route.path === "/hr/work-schedule-form" ||
                    this.$route.path === "/hr/work-schedules" ||
                    this.$route.path === "/hr/leave-day" ||
                    this.$route.path === "/hr/holidays" ||
                    this.$route.path === "/hr/shift"
            };
        },
        promotionRouter() {
            this.$store.dispatch("Promotion/setPromotion").then(() => {
                this.$store.dispatch("Promotion/clearSearch");
            });
        },
        promotionActive() {
            return {
                active:
                    this.$route.path === "/promotions" ||
                    this.$route.path === "/promotions-form" ||
                    this.$route.path === "/promotions-other" ||
                    this.$route.path === "/promotions-other-form"
            };
        },
        saleReturnProductsRouter() {
        },
        quotaRoute() {
            return canSaleView() && !canViewSuperAdmin() ? '/quota-sale-create' : '/quota-config'
        },
        quotaRouter() {
        },
        quotaSaleRouter() {
        },
        saleReturnProductsActive() {
            return {
                active:
                    this.$route.path === "/sale-return-products" ||
                    this.$route.path === "/sale-return-products-form1" ||
                    this.$route.path === "/sale-return-products-form2"
            };
        },
        quotaActive() {
            return {
                active:
                    this.$route.path === "/quota" ||
                    this.$route.path === "/quota-config" ||
                    this.$route.path === "/quota-list" ||
                    this.$route.path === "/quota-sale-list" ||
                    this.$route.path === "/quota-sale-create"
            };
        },
        // quotaSaleActive() {
        //     return {
        //         active:
        //             this.$route.path === "/quota-sale" ||
        //             this.$route.path === "/quota-sale-list"
        //     };
        // },
        creditDebitActive() {
            return {
                active:
                    this.$route.path === "/account/statement" ||
                    this.$route.path === "/account/statement-form"
            };
        },
        showLogoutModal() {
            this.$refs.logout.show();
        },
        hideLogoutModal() {
            this.$refs.logout.hide();
        }
    }
};
</script>

<style lang="scss" scoped>
.nav-link {
    padding: 0.5em 0;
    color: white;
}

.nav-item {
    cursor: pointer;
    padding: 0.5em 0;
}

.padding-left {
    padding-left: 20%;
}

.font {
    font-size: medium;
}

.nav-item.active {
    background-color: #343a40;
}

li.nav-item.active {
    background-color: #343a40;
}

ul.text-left.nav.flex-column {
    width: 100%;
}

div#menu_nav_collapse.navbar-collapse.collapse {
    margin-right: -1em;
}
</style>
